import { render, staticRenderFns } from "./VouchList.vue?vue&type=template&id=348e3b56&scoped=true&"
import script from "./VouchList.vue?vue&type=script&lang=js&"
export * from "./VouchList.vue?vue&type=script&lang=js&"
import style0 from "./VouchList.vue?vue&type=style&index=0&id=348e3b56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348e3b56",
  null
  
)

export default component.exports